var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBitcoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 21,
    viewBox: "0 0 37 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2255_37846)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.3193 13.6341C27.0327 18.7956 21.8033 21.9332 16.6492 20.6465C11.4876 19.3599 8.34996 14.1307 9.63665 8.97668C10.9233 3.8152 16.1451 0.6776 21.3067 1.96428C26.4608 3.24337 29.606 8.47256 28.3193 13.6341Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5629 9.36632C23.751 8.08739 22.7805 7.39526 21.4414 6.93634L21.8777 5.1985L20.8245 4.93519L20.4032 6.62789C20.1248 6.56019 19.839 6.49248 19.5531 6.43229L19.9744 4.73206L18.9211 4.46875L18.4923 6.19907C18.2591 6.14641 18.0334 6.09375 17.8152 6.04109V6.03357L16.3557 5.67245L16.0774 6.80093C16.0774 6.80093 16.8598 6.98148 16.8447 6.989C17.2736 7.09433 17.3488 7.38021 17.3337 7.6059L16.8372 9.58449C16.8673 9.59202 16.9049 9.59954 16.9501 9.62211C16.9125 9.61458 16.8748 9.60706 16.8372 9.59202L16.1451 12.3605C16.0924 12.4884 15.957 12.684 15.6636 12.6088C15.6711 12.6238 14.8962 12.4207 14.8962 12.4207L14.3696 13.6319L15.7464 13.978C16.0022 14.0457 16.2504 14.1059 16.4987 14.1736L16.0623 15.9265L17.1156 16.1898L17.5519 14.452C17.8378 14.5272 18.1237 14.6024 18.3945 14.6701L17.9657 16.4005L19.0189 16.6638L19.4553 14.9109C21.2608 15.2494 22.615 15.114 23.1792 13.4815C23.6381 12.1725 23.1567 11.4126 22.2087 10.9161C22.9084 10.7581 23.4275 10.2992 23.5629 9.36632ZM21.148 12.7517C20.8245 14.0608 18.6127 13.3536 17.898 13.173L18.4773 10.8484C19.192 11.0289 21.494 11.3825 21.148 12.7517ZM21.479 9.34375C21.1781 10.5399 19.3424 9.93056 18.7481 9.78009L19.2747 7.67361C19.8691 7.82407 21.7875 8.10243 21.479 9.34375Z",
    fill: "#6C7080"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2255_37846"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.5555,
    height: 20,
    fill: "white",
    transform: "translate(0.458984 0.935547)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoin);
export default __webpack_public_path__ + "static/media/bitcoin.5ebf4930c69ef65a1fa33316dc9efbab.svg";
export { ForwardRef as ReactComponent };